<div class="main-container" data-cy="patient-portal-check-in-main-container">

  <div class="main-title" data-cy="patient-portal-check-in-main-title-text">
    Appointment Check in
  </div>

  <div class="sub-title" data-cy="patient-portal-check-in-appointment-name-text">
    {{ appointmentName }}
  </div>

  <div class="qr-title" data-cy="patient-portal-check-in-qr-title-text">
     Scan this QR Code at the front desk
  </div>
  <div class="qr-container" data-cy="patient-portal-check-in-qr-code-container">
    <qr-code [level]="1" [value]="checkinQRCodeText" data-cy="patient-portal-check-in-qr-code"></qr-code>
  </div>

  <button mat-raised-button color="primary" class="done-button" (click)="close()" data-cy="patient-portal-check-in-done-action-button">Done</button>

</div>
